module.exports = __webpack_public_path__ + "img/1.009a471d.jpg";